import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CompanyAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CompanyAddIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CompanyAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CompanyAddIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={20}
      viewBox="0 0 18 20"
      data-testid="CompanyAddIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M10 0v2H2v16h5v-3.5h2V18h5V8h2v12H0V2a2 2 0 0 1 2-2zm3 14v2h-2v-2zm-8 0v2H3v-2zm8-5v2h-2V9zM9 9v2H7V9zM5 9v2H3V9zm4-5v2H7V4zM5 4v2H3V4zm11-4v2h2v2h-2v2h-2V3.999L12 4V2l2-.001V0z"
        clipRule="evenodd"
      />
    </svg>
  )
);
CompanyAddIcon.displayName = "CompanyAddIcon";
export default CompanyAddIcon;
